import { render, staticRenderFns } from "./VideoButtonModal.vue?vue&type=template&id=dc0ddef6"
import script from "./VideoButtonModal.vue?vue&type=script&lang=js"
export * from "./VideoButtonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/vercel/path0/components/ui/c-image.vue').default,FloatingModal: require('/vercel/path0/components/FloatingModal.vue').default})
